import { useOrganization, useUser } from "@sophy-ai/auth/nextjs/client"
import type { ProviderAuthContext } from "./workos-shared"

export function useAuth(): ProviderAuthContext {
  const { user, isLoaded: isUserLoaded } = useUser()
  const { organization, isLoaded: isOrganizationLoaded } = useOrganization()

  const isLoading = !isUserLoaded || !isOrganizationLoaded

  if (isLoading) {
    return {
      user: null,
      organization: null,
      isAuthenticated: false,
      isLoading: true,
    }
  }

  if (!user || !organization) {
    return {
      user: null,
      organization: null,
      isAuthenticated: false,
      isLoading: false,
    }
  }

  return {
    user: {
      id: user.id,
      authUserId: user.id,
      email: user.primaryEmailAddress?.emailAddress || "",
      name: user.fullName || "",
      role: "engineer",
      organizationId: organization.id,
      createdAt: new Date(),
      updatedAt: new Date(),
    },
    organization: {
      id: organization.id,
      authOrgId: organization.id,
      name: "Organization",
      plan: "standard",
      stripeCustomerId: undefined,
      createdAt: new Date(),
      updatedAt: new Date(),
    },
    isAuthenticated: true,
    isLoading: false,
  }
}
